import React from 'react';
import { motion } from 'framer-motion';
import { Wallet, CreditCard, ShoppingBag, Briefcase, Gem, Package, FileText, Wrench, Scissors, PenTool, Sparkles, HardDrive, Plus } from 'lucide-react';
const projects = [{
  icon: Wallet,
  label: 'Billeteras Plegables (Bifolds)'
}, {
  icon: CreditCard,
  label: 'Tarjeteros Minimalistas'
}, {
  icon: ShoppingBag,
  label: 'Bolsos Tote (Tote Bags)'
}, {
  icon: Briefcase,
  label: 'Bolsos Bandolera y Cruzados'
}, {
  icon: Gem,
  label: 'Carteras de Lujo'
}, {
  icon: Package,
  label: 'Organizadores y Estuches'
}, {
  icon: FileText,
  label: 'Instrucciones Claras por Cada Patrón'
}, {
  icon: Wrench,
  label: 'Guía de Herramientas Esenciales (eBook)'
}, {
  icon: Scissors,
  label: 'Selección y Tipos de Cuero (eBook)'
}, {
  icon: PenTool,
  label: 'Técnicas de Costura Profesional (eBook)'
}, {
  icon: Sparkles,
  label: 'Secretos de Acabados y Bordes (eBook)'
}, {
  icon: HardDrive,
  label: 'Acceso a Google Drive Organizado'
}, {
  icon: Plus,
  label: '¡Y Mucho Más!'
}];
export function ProjectTypes() {
  return <section className="bg-offwhite py-20 px-4 sm:px-6 lg:px-8" data-id="element-156">
      <div className="max-w-6xl mx-auto" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-158">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-leather-dark mb-4" data-id="element-159">
            Tipos de Proyectos y Contenidos Que Explorarás Hoy
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-160"></div>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-161">
          {projects.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center hover:shadow-md transition-shadow group" data-id="element-162">
                <div className="w-12 h-12 rounded-full bg-cream flex items-center justify-center mb-4 group-hover:bg-gold/20 transition-colors" data-id="element-163">
                  <Icon className="w-6 h-6 text-leather-warm" data-id="element-164" />
                </div>
                <span className="text-gray-800 font-medium text-sm sm:text-base" data-id="element-165">
                  {item.label}
                </span>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}